<div
    class="relative group overflow-hidden rounded-lg relative h-9 w-9 flex items-end justify-center"
    [ngClass]="{
        'w-[120px] h-[120px]': size == 'profileView',
        'w-[104px] h-[104px]': size == 'dynamicPanelView',
        'w-16 h-16': size == 'xxl',
        'w-14 h-14': size == 'xl',
        'w-12 h-12': size == 'lg',
        'h-9 w-9': size == 'md',
        'h-8 w-8': size == 'sm',
    }">
    <img
        class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-0 h-full w-full object-cover"
        (error)="onProfileImageFailedToLoad()"
        src="{{ userAvatar }}" />

    @if (uploadImageEnabled) {
        <input
            type="file"
            onclick="this.value = null"
            id="avatar"
            class="hidden"
            (change)="onFileChange($event)"
            #fileInput />

        <p-button
            (click)="fileInput.click()"
            size="small"
            severity="contrast"
            class="absolute z-50 bottom-2 hidden group-hover:block"
            label="Change picture" />
    }

    @if (isSaved || isQuietMode) {
        <div class="w-full flex items-end">
            @if (isQuietMode) {
                <div
                    class="mr-auto border border-white bg-h20 z-10 flex items-center justify-center border-l-transparent border-b-transparent"
                    [ngClass]="{
                        'w-5 h-5 text-10': size == 'xxl',
                        'w-4 h-4 text-10': size == 'xl',
                        'w-[22px] h-[22px] text-[14px]': size == 'lg',
                        'w-[17px] h-[17px] text-9': size == 'md',
                        'w-[14px] h-[14px] text-7': size == 'sm',
                    }"
                    style="border-top-right-radius: 8px; border-bottom-left-radius: 8px">
                    <fa-icon class="text-blue-bright" [icon]="faMicrophoneSlash" />
                </div>
            }
            @if (isSaved) {
                <div
                    class="ml-auto border border-white bg-blurple-light z-10 flex items-center justify-center border-r-transparent border-b-transparent"
                    [ngClass]="{
                        'w-7 h-7 text-14': size == 'dynamicPanelView',
                        'w-5 h-5 text-10': size == 'xxl',
                        'w-4 h-4 text-10': size == 'xl',
                        'w-[22px] h-[22px] text-[14px]': size == 'lg',
                        'w-[17px] h-[17px] text-9': size == 'md',
                        'w-[14px] h-[14px] text-7': size == 'sm',
                    }"
                    style="border-top-left-radius: 8px; border-bottom-right-radius: 8px">
                    <fa-icon class="text-white" [icon]="faStar" />
                </div>
            }
        </div>
    }
</div>
